import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

// The centered card used by sign-in, sign-up and the email link pages.
function AuthCard({ title, subtitle, children, footer }) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="text-center mb-4">
          <Link to="/" className="brand justify-content-center mb-4">
            <LogoMark />
            <span className="brand-text">Plateo</span>
          </Link>
          <h1 className="h4 fw-bold mb-1">{title}</h1>
          {subtitle && <p className="text-muted small mb-0">{subtitle}</p>}
        </div>
        {children}
        {footer && <p className="text-center small text-muted mt-4 mb-0">{footer}</p>}
        <div className="auth-links">
          <Link to="/terms">Terms</Link>
          <span className="mx-2 text-muted">·</span>
          <Link to="/privacy">Privacy</Link>
        </div>
      </div>
    </div>
  );
}

export default AuthCard;
